import React from 'react';
import { CellContainer } from './';
import { jsx as _jsx } from "react/jsx-runtime";

const Row = ({
  index,
  data,
  tableManager,
  measureRef
}) => {
  const {
    config: {
      isVirtualScroll,
      rowIdField
    },
    rowEditApi: {
      editRow,
      getIsRowEditable
    },
    rowSelectionApi: {
      getIsRowSelectable,
      selectedRowsIds
    },
    columnsApi: {
      visibleColumns
    },
    paginationApi: {
      page,
      pageSize
    },
    rowVirtualizer: {
      virtualItems,
      totalSize
    }
  } = tableManager;

  if (isVirtualScroll) {
    if (index === 'virtual-start') {
      return visibleColumns.map(visibleColumn => {
        var _virtualItems$;

        return /*#__PURE__*/_jsx("div", {
          style: {
            minHeight: (_virtualItems$ = virtualItems[0]) == null ? void 0 : _virtualItems$.start
          }
        }, `${index}-${visibleColumn.id}`);
      });
    }

    if (index === 'virtual-end') {
      return visibleColumns.map(visibleColumn => {
        var _virtualItems;

        return /*#__PURE__*/_jsx("div", {
          style: {
            minHeight: totalSize - ((_virtualItems = virtualItems[virtualItems.length - 1]) == null ? void 0 : _virtualItems.end) || 0
          }
        }, `${index}-${visibleColumn.id}`);
      });
    }
  }

  let rowIndex = index + 1 + pageSize * (page - 1);
  let rowId = (data == null ? void 0 : data[rowIdField]) || rowIndex;
  let disableSelection = !data || !getIsRowSelectable(data);
  let isSelected = !!data && !!selectedRowsIds.find(selectedRowId => selectedRowId === rowId);
  let isEdit = !!data && (editRow == null ? void 0 : editRow[rowIdField]) === rowId && !!getIsRowEditable(data);
  return visibleColumns.map((visibleColumn, colIndex) => /*#__PURE__*/_jsx(CellContainer, {
    rowId: rowId,
    data: rowId && (editRow == null ? void 0 : editRow[rowIdField]) === rowId ? editRow : data,
    rowIndex: rowIndex,
    colIndex: colIndex,
    column: visibleColumn,
    isSelected: isSelected,
    isEdit: isEdit,
    disableSelection: disableSelection,
    forwardRef: colIndex === 0 ? measureRef : undefined,
    tableManager: tableManager
  }, `${visibleColumn.id}-${rowId}`));
};

export default Row;